import { BaseApi } from '@/services/api/base-api.ts';
import zodEmployeeWithDetailDto from '@/schemas/company/zod-EmployeeWithDetailDto.js';
import { z } from 'zod';
import zodEmployeeSetDetailDto from '@/schemas/company/zod-EmployeeSetDetailDto.js';
import zodEmployeeWithOrganizationDto from '@/schemas/company/zod-EmployeeWithOrganizationDto.js';

export type EmployeeWithDetailDto = z.infer<typeof zodEmployeeWithDetailDto>;
export type EmployeeSetDetailDto = z.infer<typeof zodEmployeeSetDetailDto>;
export type EmployeeWithOrganizationDto = z.infer<
  typeof zodEmployeeWithOrganizationDto
>;

export class EmployeeApi extends BaseApi {
  constructor() {
    super();
  }

  async getAsync(empNo: number) {
    return this.requestAsync({
      schema: zodEmployeeWithOrganizationDto,
      url: `company/employee/${empNo}`,
    });
  }

  async getSettingsAsync() {
    return this.requestAsync({
      schema: zodEmployeeWithDetailDto,
      url: `company/employee/settings`,
    });
  }

  async setSettingsAsync(request: EmployeeSetDetailDto) {
    return this.requestAsync({
      schema: zodEmployeeWithDetailDto,
      url: `company/employee/settings`,
      method: 'post',
      payload: request,
    });
  }

  async searchAsync(keyword: string) {
    return this.requestAsync({
      schema: z.array(zodEmployeeWithOrganizationDto),
      url: 'company/employees/search',
      query: {
        keyword,
      },
    });
  }
}
